import React, { useState, useEffect, useCallback } from "react";
import "../../Styles/yellowcalf.css/Cashless_Balance_Report.css";
import userImg from "../../images/user.png";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import ScaleLoader from "react-spinners/ScaleLoader";

function Cashless_Balance_Report() {
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchAdmission, setSearchAdmission] = useState("");

  const fetchInitialData = useCallback(async () => {
    setLoading(true);
    try {
      const payload = {
        customer_id: Number(localStorage.getItem("customer_id")) || 1005,
        api_key:
          localStorage.getItem("api_key") || "b9359f494e77b6589ce12dd62518c585",
        language: "en",
        user_id: localStorage.getItem("user_id") || 14857,
        admission_number_search: searchAdmission, // Linked to state
        student_search: searchTerm,              // Linked to state
        dropdown: "true"
      };

      const response = await simplePostCall(
        ApiConfig.cashlessWalletreporteports,
        JSON.stringify(payload),
      );

      // Map 'data' array from the response you provided
      if (response && response.result) {
        setReportData(response.data || []);
      } else {
        setReportData([]);
      }
    } catch (error) {
      console.error("Error fetching report:", error);
    } finally {
      setLoading(false);
    }
  }, [searchTerm, searchAdmission]); // Refetch when search terms change

  useEffect(() => {
    fetchInitialData();
  }, [fetchInitialData]);

  const handleClearFilters = () => {
    setSearchTerm("");
    setSearchAdmission("");
  };

  return (
    <div className="cashless_balance_report-container" style={{ paddingTop: "25px" }}>
      <div className="cashless_balance_report-row">
        <div className="cashless_balance_report-col">
          <div className="cashless_balance_report-panel">
            <div className="cashless_balance_report-panel-body">
              <div className="cashless_balance_report-header">
                <h3 className="cashless_balance_report-title">Cashless Balance Report</h3>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="cashless_balance_report-row">
        <div className="cashless_balance_report-col">
          <div className="cashless_balance_report-panel">
            <div className="cashless_balance_report-panel-body">
              <div className="cashless_balance_report-table-responsive">
                <table id="wallet" className="cashless_balance_report-table">
                  <thead>
                    <tr className="cashless_balance_report-filters ">
                      {/* <td colSpan="2"></td> */}
                      <td colSpan="4">
                        <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
                          <input
                            type="text"
                            placeholder="Search Student"
                            className="cashless_balance_report-input"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                          <input
                            type="text"
                            placeholder="Search Admission"
                            className="cashless_balance_report-input"
                            value={searchAdmission}
                            onChange={(e) => setSearchAdmission(e.target.value)}
                          />
                          <button 
                            className="btn btn-primary rounded" 
                            onClick={handleClearFilters}
                            style={{ whiteSpace: "nowrap", backgroundColor: "#5db2e8", border: "none" }}
                          >
                            Clear Filters
                          </button>
                        </div>
                      </td>
                      <td colSpan="2"></td>
                    </tr>
                 
                    <tr>
                      <th style={{ textAlign: "center" }}>#</th>
                      <th style={{ textAlign: "center" }}>Image</th>
                      <th style={{ textAlign: "center" }}>Student</th>
                      <th style={{ textAlign: "center" }}>Admission Number</th>
                      <th style={{ textAlign: "center" }}>Grade</th>
                      <th style={{ textAlign: "center" }}>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="6" style={{ textAlign: "center", padding: "7px" }}>
                          <div className="text-center">
                              <ScaleLoader color="#F4BB44" /> 
                            </div>
                        </td>
                      </tr>
                    ) : reportData.length > 0 ? (
                      reportData.map((item, index) => (
                        <tr key={item.student_id || index}>
                          <td style={{ textAlign: "center" }}>{index + 1}</td>
                          <td style={{ textAlign: "center" }}>
                            <img
                              src={item.student_profilepicture || userImg}
                              width="35"
                              height="35"
                              alt="User"
                              className="wallet-main-img"
                              onError={(e) => { e.target.src = userImg; }}
                            />
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.student_name}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.student_admission_num}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.grade || "N/A"}
                          </td>
                          <td
                            style={{
                              textAlign: "center",
                              fontWeight: "bold",
                              color: "#2dce89",
                            }}
                          >
                            {item.wallet_amount}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="6"
                          style={{ textAlign: "center", padding: "20px" }}
                        >
                          No records found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Cashless_Balance_Report;
